import {IBizCoupon, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {ACoupon} from "@/views/editor/service/coupon/coupon";
import {ICouponPolicy} from "@/views/editor/service/types";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";

export interface ICouponMeta {
    policies: ICouponPolicy[]
}

export default class Coupon extends ACoupon implements IBizCoupon {
    readonly opt: ICouponMeta

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = meta.setting as ICouponMeta;
    }

    subs(status: EActivityStatus): CheckboxOptionType[] {
        return {
            active: this.opt.policies?.map(p => ({label: p.name, value: p.id})) ?? [],
            preheating: [],
            finished: []
        }[status]
    }

    resetMeta(status: EActivityStatus): IBusiness {
        this.meta.subs.length = 0
        this.meta.subs.push(...this.subs(status).map(s => s.value as string));
        const opt = {policies: []}
        Object.assign(this.opt, opt)
        return this;
    }

    /**
     * 设置券的策略，一般只在初始化时被调用
     *
     * @param {string} origin - 负责人
     * @param {ICouponPolicy[]} policies - 有效策略列表
     * @return {void} 无
     */
    setPolicies(origin: string, policies: ICouponPolicy[]): void {
        // [ O [ O,N ] N ]
        const oks = this.opt.policies.filter(p => p.origin == origin).map(p => p.id)
        const nks = policies.map(p => p.id)
        // 保留非origin的内容，再保留origin的，且名字在policies里的
        this.opt.policies = this.opt.policies.filter(n => n.origin != origin || nks.includes(n.id))
        // 在policies里逐个将列表中name没有的插入到本地列表中
        policies.filter(p => !oks.includes(p.id)).forEach(p => this.opt.policies.push(p))
        this.meta.subs = this.opt.policies.map(p => p.id)
        console.log(this.meta.subs)
    }
}